
      import Star from './star.vue'
      import type { App, Plugin } from 'vue'

      export const StarPlugin: Plugin = {
        install(app: App) {
          app.component('Star', Star)
        },
      }
      export { Star }
      